import React, { Component } from 'react';
import { Line, Doughnut } from 'react-chartjs-2';

const PerformanceChart = (props) => { 
    // console.log(props.performances);
    return (
        <div className="mt-5" style={{height: "400px", width: "100%", margin: "0 auto"}}>
            <Line 
                options={{
                    plugins: {
                        legend: {
                        display: false
                        },
                        title: {
                            display: true,
                            text: "Past Perfomances",
                            font: {
                                size: 24
                            },
                            padding: {
                                bottom: 20
                            }
                        },
                        tooltip: {
                        displayColors: false,
                        callbacks: {
                            title: function(context) {
                                const y = context[0].parsed.y;
                                const contest = props.performances[context[0].parsed.x];
                                return "Your Rank: " + contest.rank + " out of " + contest.total;
                            },
                            label: function(context) {
                                const y = context[0];
                                // console.log(y);

                                return "you beat " + context.parsed.y.toFixed(2) + "% participants";
                            },

                        }
                        }
                    },
                    maintainAspectRatio: false, 
                    responsive: true,
                    
                        scales: {
                        y: {
                            suggestedMin: 0,
                            suggestedMax: 100,
                            grid: {
                                // display: false
                            },
                            title: {
                                text: "Percentile (%)",
                                display: true,
                                font: {
                                size: 16
                                },
                                padding: {
                                bottom: 10
                                }
                            },
                            ticks: {
                                stepSize: 25
                            },
                        },
                        
                        x: {
                            ticks: {
                                // display: false
                            },
                            grid: {
                                display: false
                            },
                            // labelOffset: 30,
                            // padding: 30
                        }
                        }
                }} 
                data={{
                labels: props.performances?.map(obj => {
                    return obj.contest_name
                }),
                    datasets: [{
                    data: props.performances?.map(obj => {
                        return ((obj.total - obj.rank) / obj.total * 100)
                    }),
                    backgroundColor: '#001ec2',
                    hoverOffset: 4,
                    borderColor: '#076ab8',
                    pointRadius: 4,
                    pointBorderColor: '#06528f',
                    }]
            }} />
        </div>
    )
}

export default PerformanceChart;